export const Config = {
  env: process.env.NODE_ENV,
  baseCmsUrl: process.env.REACT_APP_CMS_URL,
  baseApiUrl: process.env.REACT_APP_API_URL,
  googleApiKey: process.env.REACT_APP_GOOGLE_KEY,
  googleSignInClientId: process.env.REACT_APP_GOOGLE_SIGN_IN_CLIENT_ID,
  googleGaCode: process.env.REACT_APP_GOOGLE_ANALYTICS_CODE,
  facebookSignInId: process.env.REACT_APP_FACEBOOK_SIGN_IN_CLIENT_ID,
  facebookRedirectSignInUrl: process.env.REACT_APP_FACEBOOK_REDIRECT_URI,
  lowEtaAccuracyTerritories: process.env.REACT_APP_LOW_ETA_ACCURACY_TERRITORIES,
  primaryColor: '#eedc00',
  black: '#222427',
  primaryBlue: '#0047BB',
  secondaryText: '#787878',
  green: '#00a200',
  red: '#ff0015',
} as const;
